import React from 'react'
import { Link } from 'react-router-dom'

const templates = [
  { id: 'template-1', name: 'Presentación Profesional', desc: 'Para ejecutivos y freelancers', color: '#6242BF' },
  { id: 'template-2', name: 'Servicios Premium', desc: 'Profesionales de servicios', color: '#10b981' },
  { id: 'template-3', name: 'Landing Personal', desc: 'One-page con tu información', color: '#f59e0b' },
  { id: 'template-4', name: 'Catálogo de Productos', desc: 'Negocios con productos', color: '#ec4899' },
]

function TemplatesPage() {
  return (
    <div className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-extrabold text-gray-900">Plantillas DKard</h1>
          <p className="mt-3 text-gray-600">Elige la plantilla que mejor se adapte a tu servicio</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {templates.map(t => (
            <div key={t.id} className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden">
              <div
                className="h-60 w-full flex items-center justify-center text-white"
                style={{ backgroundImage: `linear-gradient(135deg, ${t.color}, #05C0FB)` }}
              >
                <div className="text-center">
                  <div className="text-xs opacity-80">Plantilla</div>
                  <div className="text-sm font-semibold">{t.name}</div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900">{t.name}</h3>
                <p className="mt-1 text-sm text-gray-600">{t.desc}</p>
                <div className="mt-4 flex gap-3">
                  <Link to={`/templates?template=${t.id}`} className="text-primary-600 hover:text-primary-700 text-sm font-medium">Ver más →</Link>
                  <Link to={`/editor/new?template=${t.id}`} className="btn-primary text-sm">Crear con esta plantilla</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TemplatesPage
